import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { TAB } from '../../../class/appinterface';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-dashboard-tabs',
  templateUrl: './dashboard-tabs.component.html',
  styleUrls: ['./dashboard-tabs.component.css']
})
export class DashboardTabsComponent implements OnInit {

  constructor(
    private userComponentService: ComponentService,
    private activatedroute: ActivatedRoute,
    private router: Router
    
    ) { 

  }
  
  ngOnInit() {

    console.log(this.activatedroute)
    console.log(this.router.url)
    

    /**
     *  this.activatedroute.queryParams

      .subscribe(params => {
        this.api = params.api;

        this.anagraficaDati = this.templateService.getService(this.api);
        if(!this.anagraficaDati){
          return
        }
        this.anagraficaFilter = this.anagraficaDati.filter(r => r.configuration);
        
        this.titleDynamic = this.anagraficaFilter[0]['configuration']['title'];

        let id = ''
        if (params.id) {
          id = params.id
        }
        let filterList = this.anagraficaFilter[0]['configuration']['filterList'];
       
        if (filterList.includes('$')) {
          filterList = filterList.replace('$', id)
        }

        this.filter = filterList
        this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName


      });

     */


      
    
    let tabsJson: TAB[] = [
      {
        id: 0,
        title: 'Home Page',
        icon: 'user',

        component: 'HomepageComponent',


      },
      {
        id: 1,
        title: 'Dashboard',
        icon: 'user',

        component: 'DashboardComponent',


      },
     /*{
        id: 2,
        title: 'Soggetti',
        icon: 'user',
        component: 'TrasportatoriComponent',

      }*/

    ];


   

    this.userComponentService.setTabs("dashboard", tabsJson);

  }

}
